import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { Card } from "../../theme/components/index.js";
import { colorsSemantic } from "../../theme/tokens/colors-semantic.js";

/**
 * "Wie lange offen?" — the Alterspyramide over days since the last status change.
 *
 * Bars scale against the largest bucket, with a 6 % floor so a bucket holding a
 * single claim is still visible. Clicking a bucket filters the board; clicking
 * the active one clears the filter.
 */
export default function AgeBucketCard({ buckets = [], selected = null, onToggle }) {
  const { attention } = colorsSemantic;
  const max = Math.max(1, ...buckets.map((bucket) => bucket.count ?? 0));

  return (
    <Card variant="surface" sx={{ padding: "15px 17px" }}>
      <Typography
        sx={{ fontSize: "13.5px", fontWeight: 700, color: colorsSemantic.text.strong, letterSpacing: "-.1px" }}
      >
        Wie lange offen?
      </Typography>
      <Typography sx={{ fontSize: "11.5px", color: colorsSemantic.text.muted, mt: "3px", mb: "13px" }}>
        Tage seit letzter Aktion · klicken filtert
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: "9px" }}>
        {buckets.map((bucket) => {
          const count = bucket.count ?? 0;
          const isActive = selected === bucket.key;
          const color = attention.age[bucket.key] ?? attention.waiting.makler;

          return (
            <Box
              key={bucket.key}
              onClick={() => onToggle(bucket.key)}
              sx={{ display: "flex", alignItems: "center", gap: "10px", cursor: "pointer" }}
            >
              <Typography
                sx={{
                  fontSize: "11.5px",
                  color: isActive ? colorsSemantic.text.strong : colorsSemantic.text.muted,
                  fontWeight: isActive ? 700 : 500,
                  width: "74px",
                  flex: "none",
                }}
              >
                {bucket.label}
              </Typography>
              <Box
                sx={{
                  flex: 1,
                  height: "16px",
                  borderRadius: "4px",
                  backgroundColor: attention.trackStrong,
                  overflow: "hidden",
                }}
              >
                <Box
                  sx={{
                    width: `${count === 0 ? 0 : Math.max(6, Math.round((count / max) * 100))}%`,
                    height: "100%",
                    borderRadius: "4px",
                    backgroundColor: color,
                    // Dim the buckets that are not the active filter.
                    opacity: !selected || isActive ? 1 : 0.35,
                    transition: "opacity .15s ease, width .3s ease",
                  }}
                />
              </Box>
              <Typography
                sx={{
                  fontSize: "12.5px",
                  fontWeight: 700,
                  width: "20px",
                  textAlign: "right",
                  flex: "none",
                  color: isActive ? colorsSemantic.text.strong : colorsSemantic.text.mutedStrong,
                }}
              >
                {count}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Card>
  );
}

AgeBucketCard.propTypes = {
  buckets: PropTypes.arrayOf(
    PropTypes.shape({ key: PropTypes.string, label: PropTypes.string, count: PropTypes.number })
  ),
  selected: PropTypes.string,
  onToggle: PropTypes.func.isRequired,
};
